import React from "react";

const Open = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.6406 20.7987L35.8654 19.5739L37.0901 20.7987L35.8654 22.0235L34.6406 20.7987ZM8.65952 22.5308C7.70292 22.5308 6.92745 21.7553 6.92745 20.7987C6.92745 19.8421 7.70292 19.0666 8.65952 19.0666V20.7987V22.5308ZM24.2482 10.4062L25.4729 9.18149L35.8654 19.5739L34.6406 20.7987L33.4159 22.0235L23.0234 11.631L24.2482 10.4062ZM34.6406 20.7987L35.8654 22.0235L25.4729 32.4159L24.2482 31.1911L23.0234 29.9664L33.4159 19.5739L34.6406 20.7987ZM34.6406 20.7987V22.5308H8.65952V20.7987V19.0666H34.6406V20.7987Z"
        fill="white"
      />
    </svg>
  );
};

export default Open;
